import { Injectable } from '@angular/core';
import { Store, StoreConfig } from '@datorama/akita';

export interface ArtTreatmentState {
	lastTouchedAt: Readonly<Record<number, number>>;
}

export const createInitialState = (): ArtTreatmentState => ({
	lastTouchedAt: {}
});

const withoutTooth = (values: Readonly<Record<number, number>>, toothId: number): Record<number, number> =>
	Object.fromEntries(Object.entries(values).filter(([id]) => Number(id) !== toothId));

@Injectable()
@StoreConfig({ name: 'art-treatment', resettable: true })
export class ArtTreatmentStore extends Store<ArtTreatmentState> {
	constructor() {
		super(createInitialState());
	}

	touchTeeth(toothIds: readonly number[]): void {
		if (toothIds.length === 0) {
			return;
		}

		const timestamp = Date.now();
		const lastTouchedAt = { ...this.getValue().lastTouchedAt };

		for (const toothId of toothIds) {
			lastTouchedAt[toothId] = timestamp;
		}

		this.update({ lastTouchedAt });
	}

	resetTreatment(toothId: number): void {
		this.update({ lastTouchedAt: withoutTooth(this.getValue().lastTouchedAt, toothId) });
	}
}
